import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import toast from "react-hot-toast";
const initialState = {
  happyHour: false,
  happyHourTo: null,
  happyHourFrom: null,

  happyHourDiscount: null,
};
export const fetchHappyHour = createAsyncThunk(
  "happyHour/fetchHappyHour",
  async (customerId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.rasoi.launchlysoftware.in/api/getPrintData/${customerId}`,
      );

      const data = response.data[0];
      // toast.success("Happy Hour Data fetched successfully");
      console.log(data, "happyhour");

      if (!data) return rejectWithValue("No data found");

      return {
        happyHour: data.happyHour,
        happyHourTo: data.happyHourTo,
        happyHourFrom: data.happyHourFrom,
        happyHourDiscount: data.happyHourDiscount,
      };
    } catch (error) {
      return rejectWithValue(error.response?.data || "Fetch failed");
    }
  },
);

const happyHourSlice = createSlice({
  name: "happyHour",
  initialState,
  reducers: {
    stopHappyHour: (state) => {
      state.happyHour = false;
      state.happyHourTo = null;
      state.happyHourFrom = null;
      state.happyHourDiscount = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchHappyHour.fulfilled, (state, action) => {
      state.happyHour = action.payload.happyHour;
      state.happyHourTo = action.payload.happyHourTo;
      state.happyHourFrom = action.payload.happyHourFrom;
      state.happyHourDiscount = action.payload.happyHourDiscount;
    });
    builder.addCase(fetchHappyHour.rejected, (state) => {
      state.happyHour = false;
      state.happyHourTo = null;
      state.happyHourFrom = null;
      state.happyHourDiscount = null;
    });
  },
});

export const { stopHappyHour } = happyHourSlice.actions;
export default happyHourSlice.reducer;
